// extracted by mini-css-extract-plugin
export var boxItems = "_8s-1";
export var button = "_8s-5";
export var filterGroupBox = "_8s-0";
export var icon = "_8s-2";
export var iconSecondary = "_8s-4";
export var iconWrapper = "_8s-3";